import { createContext, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import useAPI from '../hooks/useAPI';
import type { IToken, ITransaction } from '../pages/TokenDashboardPage/types';
import AuthContext from './AuthContext';

interface TokenListContextType {
  tokenList: ITransaction[];
  isLoading: boolean;
  totalToken: number | null;
  totalTokenPages: number;
  refetchTransactionData: () => void;
}

const TokenListContext = createContext<TokenListContextType>({
  tokenList: [],
  isLoading: false,
  totalToken: null,
  totalTokenPages: 0,
  refetchTransactionData: () => {},
});

export default TokenListContext;

export const TokenListProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [tokenList, setTokenList] = useState<ITransaction[]>([]);
  const [totalToken, setTotalToken] = useState<number | null>(null);
  const [totalTokenPages, setTotalTokenPages] = useState<number>(0);
  const { userRole } = useContext(AuthContext);

  const { refetch: refetchTransactionData, isLoading } = useAPI({
    url: '/token/admin/list?page=1&limit=10',
    method: 'GET',
    dependencies: [userRole],
    enabled: !!userRole,
    onSuccess: data => {
      setTotalToken(data.result.totalToken);
      setTokenList(
        data?.result?.Tokens?.map((item: IToken) => ({
          tokenName: item?.tokenName,
          tokenSymbol: item?.tokenSymbol,
          tokenLogo: item?.tokenLogo,
          tokenId: item?.id,
          tokenAmount: item?.tokenAmount ?? '-',
          // transactionDate: item?.tokenTransactions[0]?.transactionDate ?? '-',
          // transactionId: item?.tokenTransactions[0]?.transactionId ?? '-',
          // status: item?.tokenTransactions[0]?.status ?? '-',
        })),
      );

      setTotalTokenPages(data.result.totalPages);
    },
    onError: () => {
      toast.error('Failed to fetch token list');
    },
  });

  return (
    <TokenListContext.Provider
      value={{
        tokenList,
        isLoading,
        totalToken,
        totalTokenPages,
        refetchTransactionData,
      }}
    >
      {children}
    </TokenListContext.Provider>
  );
};
